import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const glassPanelVariants = cva(
  "relative overflow-hidden border backdrop-blur-2xl [box-shadow:inset_0_1px_0_color-mix(in_oklab,var(--foreground),transparent_94%),0_24px_80px_color-mix(in_oklab,var(--foreground),transparent_92%)]",
  {
    variants: {
      tone: {
        default: "border-white/55 bg-background/72 text-foreground dark:border-white/10 dark:bg-card/70",
        quiet: "border-white/45 bg-muted/55 text-foreground dark:border-white/8 dark:bg-muted/52",
        dark: "border-white/12 bg-foreground/82 text-background shadow-black/25",
        signal: "border-primary/25 bg-primary/10 text-foreground",
      },
      radius: {
        md: "rounded-lg",
        lg: "rounded-xl",
        xl: "rounded-2xl",
      },
    },
    defaultVariants: { tone: "default", radius: "lg" },
  },
)

function GlassPanel({ className, tone, radius, ...props }: React.ComponentProps<"div"> & VariantProps<typeof glassPanelVariants>) {
  return <div data-slot="glass-panel" className={cn(glassPanelVariants({ tone, radius }), className)} {...props} />
}

export { GlassPanel, glassPanelVariants }
